<template>
    <div
        id="contacts"
        class="products-detail__contacts"
        v-if="data.contacts.items && data.contacts.items.length"
    >
        <h2 class="u-bottom-margin--s">{{ text.contacts }}</h2>
        <z-select
            name="type"
            v-model="params.type"
            :class="[
                'u-bottom-margin--s',
                { 'products-detail__select-disabled' : data.contacts.filters.type.length === 1 }
            ]"
            :data="data.contacts.filters.type"
            :clearable="false"
        />
        <div class="row">
            <div
                :key="index"
                class="col-default-6 col-v-tablet-12"
                v-for="(item, index) in filterByID"
            >
                <z-card full-height theme="contact">
                    <template v-slot:content>
                        <div class="card-contact">
                            <div class="card-contact__body">
                                <div class="card-contact__image" v-if="item.image">
                                    <img
                                        :alt="item.name"
                                        :src="item.image"
                                    />
                                </div>
                                <div class="card-contact__info">
                                    <h5
                                        v-if="item.name"
                                        v-html="item.name"
                                        class="card-contact__name"
                                    ></h5>
                                    <div
                                        v-if="item.position"
                                        v-html="item.position"
                                        class="card-contact__position"
                                    ></div>
                                </div>
                            </div>
                            <div class="card-contact__footer">
                                <span
                                    class="u-flex black-text"
                                    v-for="(link, index) in checkArray(item.phones)"
                                    :key="`phone-${index}`"
                                >
                                    <z-icon
                                        name="phone"
                                        width="24"
                                        height="24"
                                    />
                                    <span>{{ link }}</span>
                                </span>
                                <z-link
                                    :key="`email-${index}`"
                                    :href="`mailto:${email}`"
                                    v-for="(email, index) in checkArray(item.emails)"
                                >
                                    <z-icon
                                        name="email"
                                        width="24"
                                        height="24"
                                    />
                                    {{ email }}
                                </z-link>
                            </div>
                        </div>
                    </template>
                </z-card>
            </div>
        </div>
    </div>
</template>

<script>
import { localize } from '@/utils/i18n'

export default {
    name: 'contacts',
    data () {
        return {
            params: {
                type: null
            },
            filters: {},
            nav: {},
            list: [],
            text: {
                contacts: localize({
                    ru: 'Контакты отдела',
                    en: 'Department contacts'
                })
            }
        }
    },
    created () {
        if (this.data.contacts) {
            this.nav = this.data.contacts.nav
            this.list = this.data.contacts.items
            this.filters = this.data.contacts.filters
            this.params.type = this.filters.type.find(item => item.selected === true)?.id
        }
    },
    computed: {
        data () {
            return this.$root.app.components['products-detail'] ? this.$root.app.components['products-detail'] : {}
        },
        filterByID () {
            return this.list.filter(item => item['contact-id'] === this.params.type)
        }
    },
    methods: {
        checkArray (data) {
            if (data && data.length) return data
        }
    }
}
</script>

<style lang="scss">
.products-detail {

    &__select-disabled {
        pointer-events: none;

        .z-select__wrapper {
            margin-right: 0;

            @include breakpoint (mobile) {
                max-height: none;
            }
        }

        .z-select__selected {
            @include breakpoint (mobile) {
                white-space: normal;
            }
        }

        .z-select__arrow {
            display: none;
        }

        .z-select__container {
            @include breakpoint (mobile) {
                height: auto;
            }
        }
    }
}
</style>
